<template>
  <div class="goodList">
    <div
      class="item acea-row row-between-wrapper"
      v-for="(item, index) in goodList"
      :key="index"
    >
	    <router-link
      :to="{ path: '/detail/' + item.id }"
      :key="index"
    >
      <div class="pictrue">
        <img v-lazy="item.image" class="image" :key="item.image" />
        <img
          src="@assets/images/one.png"
          class="numPic"
          v-if="isSort === true && index === 0"
        />
        <img
          src="@assets/images/two.png"
          class="numPic"
          v-if="isSort === true && index === 1"
        />
        <img
          src="@assets/images/three.png"
          class="numPic"
          v-if="isSort === true && index === 2"
        />
      </div>
	      </router-link>
      <div class="underline">
        <div class="text">
          <div class="line1">{{ item.store_name }}</div>
          <div class="money font-color-orange">
            €<span class="num">{{ item.price }}</span>
          </div>
          <div class="vip-money acea-row row-middle">
            <div class="vip" v-if="item.vip_price && item.vip_price > 0">
              €{{ item.vip_price || 0
              }}<img src="@assets/images/vip.png" class="image" />
            </div>
            <span class="num" v-if="item.sales > 100">已售100+{{ item.unit_name }}</span>
            <span class="num" v-else>已售{{ item.sales }}{{ item.unit_name }}</span>
          </div>
          <div
            class="specs acea-row row-center-wrapper bg-color-green"
            v-if="item.is_att"
            @click.stop="openAttr(index)"
          >
            选规格
          </div>
          <div class="cart acea-row row-center-wrapper" v-else>
            <div class="num acea-row row-center-wrapper" v-if="item.cart_num">
              <div
                class="iconfont icon-jian"
                @click.stop="productReduce(index)"
              ></div>
              <div class="cart-num">{{ item.cart_num }}</div>
            </div>
            <div
              class="iconfont icon-jia font-color-green"
              :class="item.cart_num >= item.stock ? 'on' : ''"
              @click.stop="productPlus(index)"
            ></div>
          </div>
        </div>
      </div>
    </div>
    <ShopCart
      :cart="cart"
      v-on:reduce="reduce"
      v-on:plus="plus"
      v-on:delGood="delGood"
      v-on:settlement="settlement"
    ></ShopCart>
    <ProductAttr
      :attr="attr"
      v-on:myattr="myattr"
      v-on:changeattr="ChangeAttr"
      v-on:gocat="attrGoCat"
      v-on:attrreduce="attrReduce"
    ></ProductAttr>
  </div>
</template>
<script>
import {
  getCategory,
  getProducts,
  getProductDetail,
  postCartAdd,
  getCartCount,
  getCartList,
  postCartDel,
  changeCartNum
} from "@api/store";
import ShopCart from "@components/ShopCart";
import ProductAttr from "@components/ProductAttr";
import Loading from "@components/Loading";
import { mapGetters } from "vuex";
import debounce from "lodash.debounce";
import { mul, add } from "@utils/bc";


export default {
  name: "GoodList",
  components: {
    ShopCart,
    ProductAttr,
    Loading
  },
  props: {
    goodList: {
      type: Array,
      default: () => [],
    },
    isSort: {
      type: Boolean,
      default: true
    }
  },   
  data: function() {
    return {
      active: 0,
      category: [],
      categoryTwo: [],
      navActive: 0,
      goodList: [],
      where: {
        page: 1,
        limit: 20,
        keyword: "",
        cid: 0, //一级分类id
        sid: 0, //二级分类id
        news: 0,
        priceOrder: "",
        salesOrder: "",
        type: 1
      },
      loading: false,
      loadend: false,
      price: 0,
      stock: 0,
      nows: false,
      gradeSwitch: 1,
      attr: {
        activeAttr: false,
        productAttr: [],
        productSelect: {}
      },
      productValue: [],
      storeInfo: {},
      attrValue: "",
      id: 0, //产品id；
      cart: {
        CartCount: 0,
        animated: false,
        cartList: [],
        countmoney: 0,
        iShidden: true
      },
      isNewOpen: true,
      invalidNum: 0,
      i: 1
	};
  },
  destroyed() {
	//console.log("destroyed");
  },
  watch: {
    $route(n) {
	  //console.log(n.name);
      //if (n.name === "GoodSearch") {
      //if (this.$route.params.pid) this.where.cid = this.$route.params.pid;
      //if (this.isNewOpen) {
      //  this.getCategoryData(this.where.cid);
      //}
      //this.getCartList();
	  //console.log("1");
      //this.cart.iShidden = true;
      //}
    }
  },
 created() {
	//console.log("created");
	this.getCategoryData();
    this.getCartList();
    this.cart.iShidden = true;
  },
  computed: mapGetters(["isLogin"]),
  mounted: function() {
    //this.where.cid = this.$route.params.pid;
	//console.log(this.where.cid);
    //this.getCategoryData();
    //getCartList();
    //this.$scroll(this.$refs.container, () => {
    //  !this.loading && this.getGoodlist();
    //});
    // window.addEventListener("scroll", this.handleScroll, true);
  },
  methods: {
    // handleScroll() {
    //   // 页面滚动距顶部距离
    //   let scrollTop =
    //     window.pageYOffset ||
    //     document.documentElement.scrollTop ||
    //     document.body.scrollTop;
    //   let scroll = scrollTop - this.i;
    //   this.i = scrollTop;
    //   let u = navigator.userAgent;
    //   let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
    //   if (isAndroid) {
    //     if (scroll <= 0) {
    //       this.direction = 1; //向上
    //     } else {
    //       this.direction = 0; //向下
    //     }
    //   } else {
    //     if (scroll <= 0) {
    //       this.direction = 0;
    //     } else {
    //       this.direction = 1;
    //     }
    //   }
    // },
    goDetail: function(index) {
      this.isNewOpen = false;
      this.$router.push({ path: "/detail/" + this.goodList[index].id });
    },
    getCategoryData: function(navIg) {
      let that = this;
      getCategory().then(res => {
        that.$set(that, "category", res.data);
		
//        if (navIg) {
//         that.category.forEach(function(val, index) {
//            if (val.id === parseInt(navIg)) {
//             that.active = index;
//              that.navActive = 0;
//            }
//          });
//          if (res.data[that.active].children.length) {
//            that.where.sid = res.data[that.active].children[0].id;
//          } else {
//            that.where.sid = "";
//          }
//          that.where.cid = navIg;
//          that.categoryTwo = res.data[that.active].children;
//        } else {
//          that.where.cid = res.data[0].id;
//          // that.where.sid = res.data[0].children[0].id;
//          that.where.sid = res.data[0].children.length
//            ? res.data[0].children[0].id
//            : 0;
//          that.$set(that, "categoryTwo", res.data[0].children);
//        }
        that.$set(this, "goodList", []);
        that.where.page = 1;
        that.loadend = false;
        that.loading = false;
        //that.getGoodlist(true);
        that.getCartCount();
      });
    },

    oneSortTap: function(index) {
      this.active = index;
      this.navActive = 0;
      this.$set(this, "categoryTwo", this.category[index].children);
      this.$set(this, "goodList", []);
      this.where.cid = this.category[index].id;
      if (this.categoryTwo.length) {
        this.where.sid = this.categoryTwo[0].id;
      } else {
        this.where.sid = -1;
      }
      this.where.page = 1;
      this.loadend = false;
      this.loading = false;
      this.getGoodlist();
    },
    twoSortTap: function(index) {
      this.navActive = index;
      this.$set(this, "goodList", []);
      this.where.cid = this.category[this.active].id;
      this.where.sid = this.categoryTwo[index].id;
      this.where.page = 1;
      this.loadend = false;
      this.loading = false;
      this.getGoodlist();
    },
    // submitForm: function() {
    //   this.$set(this, "goodList", []);
    //   this.where.page = 1;
    //   this.loadend = false;
    //   this.loading = false;
    //   this.getGoodlist();
    // },
    //点击事件处理
    set_where: function(index) {
      let that = this;
      switch (index) {
        case 1:
          if (that.price === 0) that.price = 1;
          else if (that.price === 1) that.price = 2;
          else if (that.price === 2) that.price = 0;
          that.stock = 0;
          that.gradeSwitch = index;
          break;
        case 2:
          if (that.stock === 0) that.stock = 1;
          else if (that.stock === 1) that.stock = 2;
          else if (that.stock === 2) that.stock = 0;
          that.price = 0;
          that.gradeSwitch = index;
          break;
        case 3:
          that.nows = !that.nows;
          break;
        default:
          break;
      }
      that.$set(that, "goodList", []);
      that.where.page = 1;
      that.loadend = false;
      that.loading = false;
      that.getGoodlist();
    },
    //设置where条件
    setWhere: function() {
      let that = this;
      if (that.price === 0) {
        that.where.priceOrder = "";
      } else if (that.price === 1) {
        that.where.priceOrder = "asc";
      } else if (that.price === 2) {
        that.where.priceOrder = "desc";
      }
      if (that.stock === 0) {
        that.where.salesOrder = "";
      } else if (that.stock === 1) {
        that.where.salesOrder = "asc";
      } else if (that.stock === 2) {
        that.where.salesOrder = "desc";
      }
      that.where.news = that.nows ? "1" : "0";
    },
    myattr: function(e) {
      this.attr.activeAttr = e;
      this.$set(this.attr, "productSelect", {});
    },
    openAttr: function(index) {
      let that = this;
      that.id = that.goodList[index].id;
      getProductDetail(that.id, "/1").then(res => {
        that.$set(that.attr, "productAttr", res.data.productAttr);
        that.$set(that, "productValue", res.data.productValue);
        that.$set(that, "storeInfo", res.data.storeInfo);
        that.$set(
          that.attr.productSelect,
          "store_name",
          that.storeInfo.store_name
        );
        that.$set(that.attr.productSelect, "cart_num", 0);
        that.DefaultSelect();
      });
    },
    //  产品列表 加 的点击事件；
    productPlus: function(index) {
      let that = this,
        listw = that.goodList;
      that.id = listw[index].id;
      if (listw[index].cart_num >= listw[index].stock) return false;
      that.goCat(index, listw);
    },
    //产品列表 加 的功能；
    publicPlus: function(index, listw) {
      listw[index].cart_num++;
      if (listw[index].cart_num >= listw[index].stock) {
        this.$set(listw, "cart_num", listw[index].stock);
      }
    },
    //  产品列表 减 的点击事件；
    productReduce: function(index) {
      let that = this,
        listw = that.goodList,
        id = listw[index].id;
      that.cart.cartList.forEach(function(item, i) {
        if (id === item.product_id) {
          that.reduce(i);
        }
      });
    },
    //产品列表 减 的功能；
    publicReduce: function(index, listw) {
      listw[index].cart_num--;
      if (listw[index].cart_num <= 1) {
        this.$set(listw, "cart_num", 1);
      }
    },
    DefaultSelect: function() {
      let productAttr = this.attr.productAttr,
        value = [];
      for (var i = 0; i < productAttr.length; i++) {
        this.$set(productAttr[i], "index", 0);
        value.push(productAttr[i].attr_values[0]);
      }
      let attrTxt = value.sort().join(",");
      this.$set(this.attr.productSelect, "specs", attrTxt);
      //sort();排序函数:数字-英文-汉字；
      //join() 方法用于把数组中的所有元素放入一个字符串。
      let productSelect = this.productValue[attrTxt];
      if (productSelect) {
        this.$set(this.attr.productSelect, "image", productSelect.image);
        this.$set(this.attr.productSelect, "price", productSelect.price);
        this.$set(this.attr.productSelect, "stock", productSelect.stock);
        this.$set(this.attr.productSelect, "unique", productSelect.unique);
        this.$set(this.attr.productSelect, "cart_num", productSelect.cart_num);
        this.$set(this, "attrValue", value.sort().join(","));
      } else {
        this.$set(this.attr.productSelect, "image", this.storeInfo.image);
        this.$set(this.attr.productSelect, "price", this.storeInfo.price);
        this.$set(this.attr.productSelect, "stock", 0);
        this.$set(this.attr.productSelect, "unique", "");
        this.$set(this.attr.productSelect, "cart_num", 0);
        this.$set(this, "attrValue", "");
      }
      this.attr.activeAttr = true;
    },
    ChangeAttr: function(res) {
      this.$set(this.attr.productSelect, "specs", res);
      let productSelect = this.productValue[res];
      if (productSelect) {
        this.$set(this.attr.productSelect, "image", productSelect.image);
        this.$set(this.attr.productSelect, "price", productSelect.price);
        this.$set(this.attr.productSelect, "stock", productSelect.stock);
        this.$set(this.attr.productSelect, "unique", productSelect.unique);
        this.$set(this.attr.productSelect, "cart_num", productSelect.cart_num);
        this.$set(this, "attrValue", res);
      } else {
        this.$set(this.attr.productSelect, "image", this.storeInfo.image);
        this.$set(this.attr.productSelect, "price", this.storeInfo.price);
        this.$set(this.attr.productSelect, "stock", 0);
        this.$set(this.attr.productSelect, "unique", "");
        this.$set(this.attr.productSelect, "cart_num", 0);
        this.$set(this, "attrValue", "");
      }
    },
    //  属性购物车加；
    attrGoCat: function() {
      let attrList = this.attr.productSelect;
      if (attrList.cart_num >= attrList.stock) return;
      this.goCat();
      attrList.cart_num++;
      if (attrList.cart_num > attrList.stock) {
        this.$set(
          this.productValue[this.attrValue],
          "cart_num",
          attrList.stock
        );
      } else {
        this.$set(
          this.productValue[this.attrValue],
          "cart_num",
          attrList.cart_num
        );
      }
    },
    //属性购物车减；
    attrReduce: function() {
      let that = this,
        attrList = that.attr.productSelect;
      attrList.cart_num--;
      if (attrList.cart_num < 1) {
        that.$set(that.productValue[that.attrValue], "cart_num", 0);
      } else {
        that.$set(
          that.productValue[that.attrValue],
          "cart_num",
          attrList.cart_num
        );
      }
      that.cart.cartList.forEach(function(item, index) {
        if (attrList.unique === item.product_attr_unique) {
          let list = that.cart.cartList[index];
          list.cart_num--;
          if (list.cart_num < 1) {
            postCartDel([list.id]).then(function() {
              that.cart.cartList.splice(index, 1);
              if (that.cart.cartList.length < 1) {
                that.cart.iShidden = true;
              }
            });
          }
          that.countMoney();
          that.syncCartNum(list);
        }
      });
    },
    // 加入购物车；
    goCat: function(index, listw) {
      let that = this;
      let q = {
        productId: that.id,
        cartNum: 1,
        new: 0,
        uniqueId:
          that.attr.productSelect !== undefined
            ? that.attr.productSelect.unique
            : ""
      };
      postCartAdd(q)
        .then(() => {
          that.getCartCount(true);
          that.getCartList();
          if (index !== undefined) {
            that.publicPlus(index, listw);
          }
        })
        .catch(res => {
          that.$dialog.error(res.msg);
        });
    },
    //获取购物车数量
    getCartCount: function(isAnima) {
      let that = this;
      const isLogin = that.isLogin; //true为登录状态；
      if (isLogin) {
        getCartCount({ numType: 0 }).then(res => {
          that.cart.CartCount = res.data.count - that.invalidNum;
          if (isAnima) {
            that.cart.animated = true;
            setTimeout(function() {
              that.cart.animated = false;
            }, 500);
          }
        });
      }
    },
    getCartList: function() {
      let that = this;
      const isLogin = that.isLogin;
      if (isLogin) {
        getCartList().then(res => {
		  //console.log("333333333333333");
          that.$set(that.cart, "cartList", res.data.valid);
          let cartNum = 0;
          let invalid = res.data.invalid;
          for (let i = 0; i < invalid.length; i++) {
            cartNum = add(cartNum, invalid[i].cart_num);
			//console.log("2222222222222222");
          }
          that.invalidNum = cartNum;
          that.countMoney();
        });
      }
    },
    //购物车加
    plus: function(index) {
      let that = this;
      let list = that.cart.cartList[index];
      that.productId(list, 1);
      list.cart_num++;
      if (list.productInfo.attrInfo) {
        if (list.cart_num >= list.productInfo.attrInfo.stock) {
          that.$set(list, "cart_num", list.productInfo.attrInfo.stock);
        }
      } else {
        if (list.cart_num >= list.productInfo.stock) {
          that.$set(list, "cart_num", list.productInfo.stock);
        }
      }
      that.countMoney();
      that.syncCartNum(list);
    },
    //购物车减
    reduce: function(index) {
      let that = this;
      let list = that.cart.cartList[index],
        productId = list.product_id;
      that.productId(list, 0);
      list.cart_num--;
      if (list.cart_num < 1) {
        postCartDel([list.id]).then(function() {
          that.cart.cartList.splice(index, 1);
          that.goodList.forEach(function(item, index) {
            if (productId === item.id) {
              that.goodList[index].cart_num = 0;
            }
          });
          if (that.cart.cartList.length < 1) {
            that.cart.iShidden = true;
          }
        });
      }
      that.countMoney();
      that.syncCartNum(list);
    },
    //获取当前购物车在产品列表对应id的index值；
    productId: function(list, status) {
      let that = this;
      let id = list.product_id;
      let listw = that.goodList;
      listw.forEach(function(item, i) {
        if (id === item.id) {
          if (status) {
            that.publicPlus(i, listw);
          } else {
            that.publicReduce(i, listw);
          }
        }
      });
    },
    //  修改购物车数量；
    syncCartNum(cart) {
      if (!cart.sync)
        cart.sync = debounce(() => {
          changeCartNum(cart.id, Math.max(cart.cart_num, 1) || 1).then(() => {
            this.getCartCount();
          });
        }, 500);
      cart.sync();
    },
    //总共价钱；
    countMoney: function() {
      let that = this;
      let carmoney = 0;
      let array = that.cart.cartList;
      for (let i = 0; i < array.length; i++) {
        carmoney = add(carmoney, mul(array[i].cart_num, array[i].truePrice));
      }
      that.$set(that.cart, "countmoney", carmoney);
    },
    delGood: function() {
      let that = this,
        id = [],
        productId = [],
        listw = that.goodList,
        list = that.cart.cartList;
      list.forEach(function(val) {
        id.push(val.id);
        productId.push(val.product_id);
      });
      postCartDel(id).then(function() {
        list.splice(0, list.length);
        that.countMoney();
        that.getCartCount();
        that.cart.iShidden = true;
        listw.forEach(function(item, index) {
          productId.forEach(function(itemId) {
            if (item.id === itemId) {
              listw[index].cart_num = 0;
            }
          });
        });
      });
    },
    settlement: function() {
      let that = this,
        list = that.cart.cartList,
        id = [];
      list.forEach(function(val) {
        id.push(val.id);
      });
      if (id.length > 0) {
        that.$router.push({ path: "/order/submit/" + id.join(",") });
        that.cart.iShidden = true;
      } else {
        that.$dialog.toast({ mes: "请选择产品" });
      }
    }
  }
};
</script>
<style scoped>
.goodList .item{position:relative;padding-left:0.3rem;background-color:#fff;}
.goodList .item .pictrue{width:1.8rem;height:1.8rem;position:relative;}
.goodList .item .pictrue .image{width:100%;height:100%;border-radius:0.06rem;}
.goodList .item .pictrue .numPic{position:absolute;left:0.07rem;top:0.07rem;width:0.5rem;height:0.5rem;border-radius:50%;}
.goodList .item .underline{padding:0.3rem 0.3rem 0.3rem 0;border-bottom:1px solid #f5f5f5;}
.goodList .item:nth-last-child(1) .underline{border-bottom:0;}
.goodList .item .text{font-size:0.3rem;color:#222;width:4.89rem;text-align: left;}
.goodList .item .text .money{font-size:0.26rem;font-weight:bold;margin-top:0.5rem;}

.goodList .item .text .money .num{font-size:0.34rem;}
.goodList .item .text .vip-money{font-size:0.24rem;color:#282828;font-weight:bold;margin-top:0.1rem;}
.goodList .item .text .vip-money .vip{margin-right:0.22rem;}
.goodList .item .text .vip-money .image{width:0.46rem;height:0.21rem;margin-left:0.05rem;}
.goodList .item .text .vip-money .num{font-size:0.22rem;color:#aaa;font-weight:normal;margin:-0.02rem 0 0 0;}
.goodList .item .iconfont{position:absolute;right:0.3rem;width:0.5rem;height:0.5rem;border-radius:50%;font-size:0.3rem;bottom:0.38rem;}


.goodList .item .text .cart {
  position: absolute;
  right: 0.4rem;
  bottom: 0.3rem;
}
.goodList .item .text .cart .cart-num {
  width: 0.5rem;
  text-align: center;
}
.goodList .item .text .cart .iconfont {
  position: unset;
  font-size: 0.45rem;
}
.goodList .item .text .cart .iconfont.on {
  color: #ddd !important;
}
.goodList .item .text .cart .iconfont.icon-jian {
  color: #ddd;
}
.goodList .item .text .specs {
  width: 1rem;
  height: 0.4rem;
  border-radius: 0.2rem;
  font-size: 0.2rem;
  position: absolute;
  right: 0.4rem;
  bottom: 0.3rem;
  color: #fff;
}
</style>
